import { Build, Component, Element, h, Host, Prop } from '@stencil/core';
import { Parent } from 'pym.js';
import iframeResize from '@iframe-resizer/parent';

declare const iFrameResize: any;

@Component({
  tag: 'uvex-lazy-iframe',
})
export class LazyIframe {
  @Element() el!: HTMLElement;
  @Prop() src: string;
  @Prop() resizer: 'pym' | 'iframe-resizer' = 'iframe-resizer';
  private observer?: IntersectionObserver;

  async componentDidLoad() {
    if (!Build.isBrowser) {
      return;
    }
    if (!('IntersectionObserver' in window)) {
      this.loadIframe();
      return;
    }

    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (entries[0].isIntersecting) {
          this.loadIframe();
          observer.unobserve(entries[0].target);
        }
      },
      { rootMargin: '400px' },
    );
    this.observer.observe(this.el);
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = undefined;
    }
  }

  private async loadIframe() {
    if (this.resizer === 'pym') {
      new Parent('iframe', this.getIFrameTargetUrl(), {});
    }

    if (this.resizer === 'iframe-resizer') {
      iframeResize(
        {
          license: '12ajjdewwwy-26rnhw2943-1s7g1u8ma0i',
          log: false,
          checkOrigin: false,
        },
        '#iframe',
      );
    }
  }

  private getIFrameTargetUrl() {
    let target = this.src;
    let query = `${location.search.substring(1)}&parentUrl=${encodeURIComponent(location.href)}`;
    if (query.startsWith('&')) {
      query = query.substring(1);
    }
    const hash = location.hash.substring(1);
    if (target.includes('?') && query) {
      target = `${target}&${query}`;
    } else if (query) {
      target = `${target}?${query}`;
    }
    if (hash) {
      target = `${target}#${hash}`;
    }
    return target;
  }

  renderPym() {
    if (this.resizer !== 'pym') {
      return;
    }

    return <div id="iframe" />;
  }

  renderiFrameResizer() {
    if (this.resizer !== 'iframe-resizer') {
      return;
    }

    const style = {
      'width': '1px',
      'min-width': '100%',
    };

    return <iframe id="iframe" frameBorder="0" style={style} src={this.getIFrameTargetUrl()} />;
  }

  render() {
    return (
      <Host>
        {this.renderPym()}
        {this.renderiFrameResizer()}
      </Host>
    );
  }
}
